import React, { useState, useEffect, useRef } from "react";
import { deleteRequest, getAllrequest, 
  getRequestOptions, updateRequestStatus, getRequestListExcel, sendNotificationCavus } from "../services/requestService";
import { formatDate } from "../helpers/stringHelpers";
import Pagination from "../components/Pagination";
import ImageTextModal from "../components/UserModals/SendAnswerModal";
import { ArrowDownIcon, SearchIcon } from "../assets/icons";
import { Toast } from "primereact/toast";
import Spinner from "../components/common/Spinner";

export default function Talepler() {
    const [blockedAddresses, setBlockedAddresses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [blockOptions, setBlockOptions] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedDurum, setSelectedDurum] = useState("");
    const [statusUpdatingId, setStatusUpdatingId] = useState(null);
    const [notifyingId, setNotifyingId] = useState(null);
    const [sortField, setSortField] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');
    // Modal states
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRequestId, setSelectedRequestId] = useState(null);
    const [selectedKategori, setSelectedKategori] = useState(null);
    const [photoModalSrc, setPhotoModalSrc] = useState(null);
    const [selectedDetail, setSelectedDetail2] = useState(null);
    const [isModalOpen2, setIsModalOpen2] = useState(false);
    const toast = useRef(null);

    const handleOpenDetail2 = (address) => {
      setSelectedDetail2(address);
      setIsModalOpen2(true);
    };
    
    const handleCloseDetail2 = () => {
      setIsModalOpen2(false);
      setSelectedDetail2(null);
    };
    const fetchBlockedAddresses = async (filters = {}) => {
        try {
            setLoading(true);
            const params = {
                count: 15,
                offset: filters.resetPage ? 0 : currentPage,
            };

            const currentFilters = {};
            if (selectedType) currentFilters.type = selectedType;
            if (selectedDate) currentFilters.date = selectedDate;
            if (startDate) currentFilters.basla = startDate;
            if (endDate) currentFilters.bitis = endDate;
            if (searchTerm.trim()) currentFilters.search = searchTerm.trim();
            if (selectedDurum) currentFilters.durum = selectedDurum;

            const finalFilters = { ...currentFilters, ...filters };

            if (finalFilters.type) params.type = finalFilters.type;
            if (finalFilters.date) params.date = finalFilters.date;
            if (finalFilters.search) params.search = finalFilters.search;
            if (finalFilters.basla) params.basla = finalFilters.basla;
            if (finalFilters.bitis) params.bitis = finalFilters.bitis;
            if (finalFilters.durum) params.durum = finalFilters.durum;

            const response = await getAllrequest(params);

            setBlockedAddresses(response.data);
            setTotalPages(Math.ceil(response.totalRecords / 15));

            if (filters.resetPage) {
                setCurrentPage(0);
            }
        } catch (error) {
            setError(error.message || 'Veri yükleme hatası oluştu');
        } finally {
            setLoading(false);
        }
    };

    const fetchBlockOptions = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await getRequestOptions();
            setBlockOptions(response.data);
        } catch (error) {
            setError(error.message || 'Blok seçenekleri yükleme hatası oluştu');
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteBlockedAddress = async (id) => {
        try {
            await deleteRequest(id);
            fetchBlockedAddresses({});
        } catch (error) {
            setError(error.message || 'Silme işlemi hatası oluştu');
        }
    };

    const handleChangeStatus = async (address, newStatus) => {
        try {
            setStatusUpdatingId(address.requestId);
            await updateRequestStatus({ id: address.requestId, durum: newStatus });
            await fetchBlockedAddresses({});
        } catch (err) {
            setError(err.message || 'Durum güncellenemedi');
        } finally {
            setStatusUpdatingId(null);
        }
    };


    const handleSendNotificationCavus = async (requestId) => {
        try {
            setNotifyingId(requestId);
            await sendNotificationCavus(requestId);
            toast.current?.show({
                severity: 'success',
                summary: 'Başarılı',
                detail: 'Bildirim gönderildi.',
                life: 3000
            });
        } catch (err) {
            toast.current?.show({
                severity: 'error',
                summary: 'Hata',
                detail: err.response?.data?.mesaj || err.response?.data?.message || err.message || 'Bildirim gönderilemedi.',
                life: 4000
            });
        } finally {
            setNotifyingId(null);
        }
    };

    const handleOpenModal = (address) => {
      setSelectedRequestId(address.requestId);
      setSelectedKategori(address.kategori);
      setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedRequestId(null);
        setSelectedKategori(null);
    };

    const handleTypeChange = (e) => {
        const type = e.target.value;
        setSelectedType(type);
        fetchBlockedAddresses({ type, resetPage: true });
    };

    const handleDateChange = (e) => {
        const date = e.target.value;
        setSelectedDate(date);
        fetchBlockedAddresses({ date, resetPage: true });
    };

    const handleDurumChange = (e) => {
        const durum = e.target.value;
        setSelectedDurum(durum);
        fetchBlockedAddresses({ durum, resetPage: true });
    };

    const handleSearch = () => {
        fetchBlockedAddresses({ search: searchTerm.trim(), resetPage: true });
    };

    const handleFilter = () => {
        fetchBlockedAddresses({ basla: startDate, bitis: endDate, resetPage: true });
    };

    const handleDownloadExcel = async () => {
        try {
            const params = {};
            if (selectedType) params.type = selectedType;
            if (selectedDate) params.date = selectedDate;
            if (startDate) params.basla = startDate;
            if (endDate) params.bitir = endDate;
            if (searchTerm.trim()) params.search = searchTerm.trim();
            if (selectedDurum) params.durum = selectedDurum;
            // include durum if needed in future via UI
            const blob = await getRequestListExcel(params);
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `talepler_${new Date().toISOString().slice(0,10)}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setError(err.message || 'Excel indirilemedi');
        }
    };

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortOrder('asc');
        }
    };

    const sortedAddresses = React.useMemo(() => {
        if (!sortField) return blockedAddresses;
        const list = [...blockedAddresses];
        const getValue = (item) => {
            if (sortField === 'tarih') return new Date(item.tarih).getTime() || 0;
            return (item[sortField] || '').toString().toLocaleLowerCase('tr-TR');
        };
        list.sort((a, b) => {
            const va = getValue(a);
            const vb = getValue(b);
            if (va < vb) return sortOrder === 'asc' ? -1 : 1;
            if (va > vb) return sortOrder === 'asc' ? 1 : -1;
            return 0;
        });
        return list;
    }, [blockedAddresses, sortField, sortOrder]);
 
    useEffect(() => {
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
      
        const start = sevenDaysAgo.toISOString().split("T")[0];
        const end = today.toISOString().split("T")[0];
      
        setStartDate(start);
        setEndDate(end);
      
        fetchBlockOptions();
        fetchBlockedAddresses({ basla: start, bitis: end, resetPage: true });
      }, []);

    useEffect(() => {
        // Refetch when page changes
        fetchBlockedAddresses({});
    }, [currentPage]);
      

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="blocked-addresses-container request-container">
            <Toast ref={toast} />
            <div className="search-container">
                <div className="search-inputs">
                    <div className="search-input-group">
                        <select
                            value={selectedType}
                            onChange={handleTypeChange}
                            className="search-select"
                        >
                            <option value="">Tümü</option>
                            {blockOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="search-input-group">
                        <input
                            type="text"
                            placeholder="Ara..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyPress={handleSearchKeyPress}
                            className="search-input"
                        />
                        <button
                            onClick={handleSearch}
                            className="search-button"
                        >
                            <SearchIcon className="search-icon" />
                        </button>
                    </div>
                    <div className="search-input-group">
                        <select
                            value={selectedDurum}
                            onChange={handleDurumChange}
                            className="search-select"
                        >
                            <option value="">Durum (Tümü)</option>
                            <option value="Yeni Talep">Yeni Talep</option>
                            <option value="İşlemde">İşlemde</option>
                            <option value="Sonuçlandı">Sonuçlandı</option>
                        </select>
                    </div>
                    <div className="search-input-group">
                        <input
                            type="date"
                            value={selectedDate}
                            onChange={handleDateChange}
                            className="search-date-input"
                        />
                    </div>
                    <div className="search-input-group">
                        <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="p-inputtext date-input"
                            style={{ height: "43px", padding: "0 10px" }}
                        />
                    </div>
                    <div className="search-input-group">
                        <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="p-inputtext date-input"
                            style={{ height: "43px", padding: "0 10px" }}
                        />
                    </div>
                    <div className="search-input-group">
                        <button
                            onClick={() => handleFilter()}
                            className="filter-button"
                            style={{
                                width: "100px",
                                color: "white",
                                backgroundColor: "#18964e",
                                border: "0px",
                                height: "40px",cursor:"pointer",
                                borderRadius: "5px",
                            }}
                        >
                            Filtrele
                        </button>
                        <button
                            onClick={handleDownloadExcel}
                            className="download-excel-button"
                            style={{marginLeft: "8px"}}
                        >
                            Excel Çıktısı Al
                            <ArrowDownIcon color='white' className="filter-icon" />
                        </button>
                    </div>
                </div>
            </div>
            <div className="table-container">
                <table className="personel-table">
                    <thead>
                        <tr>
                            <th onClick={() => handleSort('kategori')} style={{cursor:'pointer'}}>Kategori</th>
                            <th onClick={() => handleSort('talep')} style={{cursor:'pointer'}}>Talep</th>
                            <th onClick={() => handleSort('tarih')} style={{cursor:'pointer'}}>Tarih</th>                           
                            <th onClick={() => handleSort('vatandasAdsoyad')} style={{cursor:'pointer'}}>Vatandaş</th>
                            <th onClick={() => handleSort('mah')} style={{cursor:'pointer'}}>Mahalle</th>
                            <th onClick={() => handleSort('sokak')} style={{cursor:'pointer'}}>Sokak</th>
                            <th onClick={() => handleSort('apartman')} style={{cursor:'pointer'}}>Apartman</th>
                            <th onClick={() => handleSort('kapiNo')} style={{cursor:'pointer'}}>Kapı No</th>
                            <th onClick={() => handleSort('ilce')} style={{cursor:'pointer'}}>İlçe</th>
                            <th>Bildirim</th>
                            <th>Cevap/Tarih/Foto</th>
                            <th onClick={() => handleSort('durum')} style={{cursor:'pointer'}}>Durum</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedAddresses.map((address) => (
                            <tr key={address.Id}>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.kategori}</td>
                                <td className={address.silindimi ? 'deleted' : ''} title={address.talep}>
                                    <div className="talep-text" style={{ width: "200px", maxHeight:"100px", overflow: "auto",overflowY:"scroll" }}>
                                        {address.talep}
                                        <br/>
                                        {address.foto && (
                                            <img
                                                src={address.foto}
                                                alt="Talep"
                                                style={{ width: "100px", height: "100px", cursor: "pointer" }}
                                                onClick={() => setPhotoModalSrc(address.foto)}
                                            />
                                        )}
                                    </div>
                                </td>
                                <td className={address.silindimi ? 'deleted' : ''}>{formatDate(address.tarih)}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>
                                    {address.vatandasAdsoyad}<br/>
                                    {address.eposta}<br/>
                                    {address.telefon}
                                </td>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.mah || ''}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.sokak || ''}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.apartman || ''}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.kapiNo || ''}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>{address.ilce || ''}</td>
                                <td className={address.silindimi ? 'deleted' : ''}>
                                    <button
                                        className="icon-button bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                        onClick={() => handleSendNotificationCavus(address.requestId)}
                                        disabled={notifyingId === address.requestId}
                                        style={{ minWidth: '120px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}
                                    >
                                        {notifyingId === address.requestId ? (
                                            <>
                                                <Spinner size="small" />
                                                <span>Gönderiliyor...</span>
                                            </>
                                        ) : (
                                            'Denetmene Bildir'
                                        )}
                                    </button>
                                </td>
                                <td className={address.silindimi ? 'deleted' : ''}>
                                                            
                                {address.cevap ? (<>


                                    <button
                                            className="icon-button bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                            onClick={() => handleOpenDetail2(address)}
                                        >
                                            Detay
                                        </button>
 
                                </>
                              ) : (
                                <button className="icon-button bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                    onClick={() => handleOpenModal(address)}>
                                                Cevapla
                                            </button>
                                  )}
                           
                                 </td>
                                <td className={address.silindimi ? 'deleted' : ''}>
                                    <select
                                        value={address.durum || ''}
                                        onChange={(e) => handleChangeStatus(address, e.target.value)}
                                        disabled={statusUpdatingId === address.requestId}
                                        className="icon-button bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                                        style={{color: 'inherit'}}
                                    >
                                        <option value="Yeni Talep">Yeni Talep</option>
                                        <option value="İşlemde">İşlemde</option>
                                        <option value="Sonuçlandı">Sonuçlandı</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
            />{isModalOpen2 && selectedDetail && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "20px",
                      borderRadius: "8px",
                      width: "400px",
                      maxHeight: "80vh",
                      overflowY: "auto",
                    }}
                  >
                    <h2 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>
                      Cevap Detayı
                    </h2>
              
                    {selectedDetail.cevap ? (
                      <>
                        <p>
                          {selectedDetail.cevap} / <b>{formatDate(selectedDetail.cevapTarihi)}</b>
                        </p>
                        {selectedDetail.foto && (
                          <>
                            <br />
                            <img
                                src={`${selectedDetail.foto}`}
                                style={{ maxWidth: "600px" }}
                                alt="Request Image"
                                onError={(e) => console.error("Image failed to load:", e)}
                            />
                            
                          </>
                        )}
                      </>
                    ) : (
                      <p>Henüz cevap yazılmamış.</p>
                    )}
              
                    <div style={{ marginTop: "20px", textAlign: "right" }}>
                      <button
                        onClick={handleCloseDetail2}
                        className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-700"
                      >
                        Kapat
                      </button>
                    </div>
                  </div>
                </div>
              )}
          {photoModalSrc && (
            <div
              onClick={() => setPhotoModalSrc(null)}
              style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)",
                display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 9999, cursor: "zoom-out",
              }}
            >
              <img
                src={photoModalSrc}
                alt="Talep"
                onClick={e => e.stopPropagation()}
                style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: "8px", boxShadow: "0 4px 32px rgba(0,0,0,0.5)", cursor: "default" }}
              />
            </div>
          )}
          <ImageTextModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            onSuccess={() => {
              fetchBlockedAddresses({});        
              handleCloseModal();              
            }}
            selectedRequestId={selectedRequestId} 
            kategoriAdi={selectedKategori}
            />
        </div>

        
    );
}